import { ButtonV4, VerticalDivider } from '@labrav/react-components'
import type { CloudAccountType } from '@labrav/react-components'
import type { CloudAccountTypeWithOriginalId } from '@labrav/common'
import {
  CloudAccountChangeV2,
  type CloudAccountChangeParams,
} from '@labrav/common'
import type {
  CloudMarketplace,
  Product,
} from '../../../modules/productsListing/types'
import { CreateNewListingButton } from '../CreateNewListingButton'
import { useStyles } from '../ProductListingV2.styles'
import type { ExternalPlatformType } from '../types'

type ProductListingToolbarProps = {
  isHubspot: boolean
  isImpartner: boolean
  externalBaseURL?: string
  marketplaceCloudAccounts: CloudAccountTypeWithOriginalId[]
  selectedAccountIdWithCloud: string
  onCloudAccountChange: (params: CloudAccountChangeParams) => void
  isFreeTier: boolean | undefined
  enableToCreate: boolean
  loading: boolean
  handleCreateListingSelection: Parameters<
    typeof CreateNewListingButton
  >[0]['handleCreateListingSelection']
  handleMigrateListingSelection: () => void
  selectedCloudTypeProductListing: CloudMarketplace
  externalPlatformType?: ExternalPlatformType
  productRows: Product[]
}

export const ProductListingToolbar = ({
  isHubspot,
  isImpartner,
  externalBaseURL,
  marketplaceCloudAccounts,
  selectedAccountIdWithCloud,
  onCloudAccountChange,
  isFreeTier,
  enableToCreate,
  loading,
  handleCreateListingSelection,
  handleMigrateListingSelection,
  selectedCloudTypeProductListing,
  externalPlatformType,
  productRows,
}: ProductListingToolbarProps) => {
  const { classes } = useStyles({
    isExternal: !!externalBaseURL || isHubspot,
    externalPlatformType,
  })

  const cloudSelector = (
    <div className={classes.cloudSelectorBox}>
      <CloudAccountChangeV2
        cloudAccounts={marketplaceCloudAccounts as CloudAccountType[]}
        selectedAccountId={selectedAccountIdWithCloud}
        onChange={onCloudAccountChange}
        width={220}
        size="small"
      />
    </div>
  )

  if (externalBaseURL && isHubspot) {
    return <div className={classes.cloudChangeContainer}>{cloudSelector}</div>
  }

  if (!externalBaseURL && !isHubspot && !isImpartner) {
    return (
      <>
        {cloudSelector}
        <VerticalDivider />
        <div className={classes.toolTipView}>
          <CreateNewListingButton
            isFreeTier={isFreeTier}
            enableToCreate={enableToCreate}
            loading={loading}
            handleCreateListingSelection={handleCreateListingSelection}
            selectedCloudTypeProductListing={selectedCloudTypeProductListing}
            externalBaseURL={externalBaseURL}
            externalPlatformType={externalPlatformType}
            productRows={productRows}
          />
        </div>
      </>
    )
  }

  if (isImpartner) {
    return (
      <>
        {cloudSelector}
        <ButtonV4 variant="primary" onClick={handleMigrateListingSelection}>
          Migrate listing
        </ButtonV4>
      </>
    )
  }

  return null
}
